<script lang="ts">
    import type {Criterion} from '../search-criteria/criteria.types';
    import type {SvelteComponentConstructor} from 'core/types';
    import type {ForceSetting} from 'shared/value-editors/kp-value-editor-force-settings/types';
    import {createEventDispatcher, onDestroy} from 'svelte';
    import {Subject} from 'rxjs';
    import {debounceTime} from 'rxjs/operators';
    import {createValueEditorsLabelContext, setValueEditorLabelContext} from 'shared/value-editors/internal/label/value-editor-label-context';
    import KpValueEditor from 'shared/value-editors/kp-value-editor/KpValueEditor.svelte';
    import KpValueEditorForceSettings from 'shared/value-editors/kp-value-editor-force-settings/KpValueEditorForceSettings.svelte';
    import SearchFacetsAcceptableEditorOptionLabel from '../kp-search-facets/SearchFacetsAcceptableEditorOptionLabel.svelte';

    export let criterion: Criterion;

    const isOfRangeValueEditorType = criterion.field.editor.type === 'range';
    const debouncedCriterionChangedEvent$: Subject<void> = new Subject();
    const dispatch = createEventDispatcher<{ 'criterion-change': void }>();

    // Debounce for range editor to prevent multiple searches for every slider movement
    const subscription = debouncedCriterionChangedEvent$.pipe(debounceTime(isOfRangeValueEditorType ? 250 : 0))
        .subscribe(() => dispatch('criterion-change'));

    const facetLabelContext = createValueEditorsLabelContext(criterion.field.id, criterion.field.text);
    setValueEditorLabelContext(facetLabelContext);

    onDestroy(() => subscription.unsubscribe());

    function dispatchCriterionChangedEvent() {
        debouncedCriterionChangedEvent$.next();
    }

    const singleAcceptableEditorSettings: ForceSetting<'single-acceptable'> = {
        type: 'single-acceptable',
        options: {
            switchToInlineModeThreshold: 0,
            optionLabelComponent: SearchFacetsAcceptableEditorOptionLabel as SvelteComponentConstructor<{ option }>
        },
    }

    const multipleAcceptableEditorSettings: ForceSetting<'multiple-acceptable'> = {
        type: 'multiple-acceptable',
        options: {
            switchToInlineModeThreshold: 0,
            showFirstCount: 5,
            optionLabelComponent: SearchFacetsAcceptableEditorOptionLabel as SvelteComponentConstructor<{ option }>
        }
    }
</script>

<KpValueEditorForceSettings forceSettings={[singleAcceptableEditorSettings, multipleAcceptableEditorSettings]}>
    <KpValueEditor editorId={criterion.field.id}
                   editorName={criterion.field.id}
                   {...criterion.field.editor}
                   bind:model={criterion.value}
                   on:model-change={dispatchCriterionChangedEvent}/>
</KpValueEditorForceSettings>